import React from 'react';
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";
import {FormattedMessage} from "react-intl";

// style
import {black500} from "assets/jss/main";

RetailerMappingCount.propTypes = {
    productCount: PropTypes.number,
    variationCount: PropTypes.number,
    retailerId: PropTypes.string.isRequired,
};

function RetailerMappingCount({productCount, variationCount, retailerId}) {
    if (productCount === 0 && variationCount === 0) {
        return '--';
    }

    return (
        <Link
            to={`${encodeURIComponent(retailerId)}/attributes-mapping`}
            style={{textDecoration: 'none', color: black500}}
            onClick={(e) => e.stopPropagation()}
        >
            <div style={{display: 'flex', flexDirection: 'column'}}>
                <span style={{fontSize: '14px', fontWeight: 600, whiteSpace: 'nowrap'}}>
                    <FormattedMessage id="retailer.list.table.body.products" values={{count: productCount.toLocaleString('fr-FR')}} />
                </span>
                <span style={{fontSize: '12px', whiteSpace: 'nowrap'}}>
                    <FormattedMessage id="retailer.list.table.body.variations" values={{count: variationCount.toLocaleString('fr-FR')}} />
                </span>
            </div>
        </Link>
    );
}

export default RetailerMappingCount;
